import React, { FC } from 'react';

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { isAndroid } from 'utils/environment';

import { BoxChild, FooterWrapper } from './product-cta.styled';
import { IProductCtaWrapperProps } from './types';

// Wrapper for the CTA buttons depending on the device
export const ProductCtaWrapper: FC<React.PropsWithChildren<IProductCtaWrapperProps>> = ({
  elements,
}) => {
  const { bottom } = useSafeAreaInsets();
  const elementsToRender = elements.filter(({ element }) => element);

  return (
    <FooterWrapper
      testID="product-cta-footer-banner"
      style={isAndroid ? { paddingBottom: bottom } : undefined}
    >
      {elementsToRender.map(({ element, spaces }, idx) => (
        <BoxChild key={idx} lastChild={idx === elementsToRender.length - 1} spaces={spaces}>
          {element}
        </BoxChild>
      ))}
    </FooterWrapper>
  );
};
